import React, { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';

interface HeaderProps {
    icon: LucideIcon;
    title: string;
    subtitle: string;
    onButtonClick?: () => void;
    buttonText?: string;
    buttonIcon?: LucideIcon;
    rightElement?: ReactNode;
}

const Header: React.FC<HeaderProps> = ({
    icon: Icon,
    title,
    subtitle,
    onButtonClick,
    buttonText,
    buttonIcon: ButtonIcon,
    rightElement
}) => {
    return (
        <div className="flex flex-col md:flex-row md:items-center justify-between bg-white p-6 rounded-2xl border border-slate-100 shadow-sm gap-4">
            <div>
                <div className="flex items-center gap-2 mb-1">
                    <div className="w-7 h-7 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center">
                        <Icon size={14} />
                    </div>
                    <h2 className="text-xl font-black text-slate-800">{title}</h2>
                </div>
                <p className="text-xs font-medium text-slate-400">{subtitle}</p>
            </div>

            <div className="flex items-center gap-2">
                {rightElement}

                {onButtonClick && buttonText && (
                    <button
                        onClick={onButtonClick}
                        className="bg-indigo-600 text-white px-5 py-2.5 rounded-xl text-sm font-bold shadow-sm hover:bg-indigo-700 transition-all flex items-center gap-2 whitespace-nowrap"
                    >
                        {ButtonIcon && <ButtonIcon size={16} />}
                        {buttonText}
                    </button>
                )}
            </div>
        </div>
    );
};

export default Header;
